import ApiClient from '@/helpers/api/api.helpers';
import axios from '@/helpers/api/HTTPClient.helper.js';
class Contacts extends ApiClient {
  constructor() {
    super('contacts/contacts');
  }
  addFavoriteContact(contactId) {
    return axios.post(`${this.url}/${contactId}/favorite`);
  }

  getNotes(options) {
    console.log(options);

    return axios.get(`${this.url}/notes`, options);
  }

  deleteNote(noteId) {
    return axios.delete(`${this.url}/notes/${noteId}`);
  }
}

export default new Contacts();
